import { IBroadcastCommandEventOption } from '@/interfaces';
import { TBroadcastCommandEventOptionType } from '@/types';
import { broadcastService } from '@/services';
import { useEffect } from 'react';
import { filter } from 'rxjs';

interface IUseListenEventsParams<TData = any> {
  callback: (data: TData, ...args: any[]) => void;
  type: TBroadcastCommandEventOptionType;
  args?: any[];
};

const useListenEvents = <TData = any>({ callback, type, args }: IUseListenEventsParams<TData>) => {

  useEffect(
    () => {
      const subscription = (
        broadcastService
          .observable()
          .pipe(filter(l => l.type === 'events'))
          .subscribe(
            command => {
              const payload = command.payload as IBroadcastCommandEventOption<TData>;
              payload?.type === type &&
                callback?.(payload.data!, args);
            }
          )
      );

      return () => {
        subscription.unsubscribe();
      };
    },
    [
      callback,
      type,
      ...(args ?? [])
    ]
  );

};

export default useListenEvents;
